/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getIdByLabel = (list, label) => Number(Object.keys((list || {}))?.find?.((key) => list[key] === label) || '0');

export const generateDropdownOptions = (list, defaultEntry = '') => Object.keys(list).map((item) => {
    const obj = {
        id: Number(item), // convert string to integer
        value: list[item],
        isDefault: !!(list[item] === defaultEntry),
    };
    return obj;
});

export const copyQueryBuilder = (durationText, frequencyText, subscriptionType, brand) => ({
    query: `\\"subscription_duration\\": \\"${durationText}\\",\\"subscription_interval\\":\\"${frequencyText}\\", \\"subscription_type\\": \\"${subscriptionType}\\" ,\\"default\\":false`,
    brand: brand['domain-name'],
    contentType: 'product_subscription_copy',
});

export const defaultSelectionQuery = (csEntryTitle, brand) => ({
    query: `\\"title\\": \\"${csEntryTitle}\\",\\"default\\":true`,
    brand: brand['domain-name'],
    contentType: 'product_subscription_copy',
});

export const capitalize = (value) => {
    if (typeof value !== 'string') {
        return '';
    }
    return `${value?.charAt?.(0)?.toUpperCase?.()}${value?.slice?.(1)}`;
};

export default  {};
